import { Controller } from '@hotwired/stimulus';
import {
  delay,
  once,
} from 'lodash';

export default class extends Controller {
  static get targets() {
    return ['close'];
  }

  static get values() {
    return {
      type: String,
      keepOpen: { type: Boolean, default: false }
    };
  }

  connect() {
    this.close = once(this.close.bind(this));
    this.open = once(this.open.bind(this));

    delay(this.open, 300);

    this.closeTarget.addEventListener('click', this.close);

    if (!this.keepOpenValue) {
      delay(this.close, 8000);
    }
  }

  open() {
    this.element.classList.remove('toast-closed');
    this.element.classList.remove('hidden');
    this.element.classList.add('toast-opened');
  }

  disconnect() {
    this.closeTarget.removeEventListener('click', this.close);
  }

  close() {
    const animationEndListener = () => {
      this.element.removeEventListener('animationend', animationEndListener);
      this.element.remove();
    };

    this.element.addEventListener('animationend', animationEndListener);
    this.element.classList.remove('toast-opened');
    this.element.classList.add('toast-closed');
  }
}
